import { ActionType } from "../../types/types";
import { IState } from "./iState";

export type T_SET_USER = "SET_USER";
export const SET_USER: T_SET_USER = "SET_USER";

export type ActionTypeMix = ActionType<T_SET_USER, IState>;
